import { render, staticRenderFns } from "./DetalleSolicitudComprobacionAMEX.vue?vue&type=template&id=53b0e910&"
import script from "./DetalleSolicitudComprobacionAMEX.vue?vue&type=script&lang=js&"
export * from "./DetalleSolicitudComprobacionAMEX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DetalleSolicitudComprobacionAMEX.vue"
export default component.exports